import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex w-fit items-center gap-1.5 rounded-md border px-2 py-0.5 text-sm font-medium leading-5',
  {
    variants: {
      variant: {
        default: 'border-border bg-muted text-foreground',
        secondary: 'border-border bg-secondary text-secondary-foreground',
        outline: 'border-border bg-card text-muted-foreground',
        success: 'border-success/20 bg-success-surface text-success-foreground',
        warning: 'border-warning/30 bg-warning-surface text-warning-foreground',
        danger: 'border-destructive/20 bg-destructive-surface text-destructive',
        proposal: 'border-dashed border-proposal/40 bg-proposal-surface text-proposal',
        selected: 'border-primary/30 bg-selected text-selected-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export function Badge({ className, variant, ...props }: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
